import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';

import DetailCardFields from '#client/components/DetailCardFields';

export default function CardDetails() {
  return (
    <Stack gap="24px">
      <Heading
        family="secondary"
        size="2xl"
        weight="bold"
      >
        Virtual debit card details
      </Heading>
      <Stack gap={{ xs: '16px' }}>
        <DetailCardFields />
      </Stack>
    </Stack>
  );
}
